
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import { i18n } from './i18n'
// Global admin UI stylesheet (shared buttons, tables, forms)
import './styles/admin.css'

// Allow overriding API base in production if needed (e.g. CDN or different domain)
axios.defaults.baseURL = import.meta.env.VITE_API_BASE || ''

createApp(App).use(i18n).use(router).mount('#app')

